import { useQuery } from "@tanstack/react-query";
import { CHANGELOGS_QUERY_KEYS } from "../configs/queryKeys";
import { ChangelogsService } from "../services/changelogs.service";

export const useLatestPopup = () => {
  const { data, isLoading } = useQuery({
    queryKey: CHANGELOGS_QUERY_KEYS.latestPopup(),
    queryFn: () => ChangelogsService.getLatestPopup(),
    staleTime: Infinity,
    retry: false,
  });

  return {
    changelog: data?.changelog ?? null,
    isLoading,
  };
};
